/**
 * Input → Commands. Klick på kartan = MoveShip för den lokala spelaren.
 * Producerar bara Command-objekt — ingen spellogik här (arkitekturregel 5).
 */
import type { Command } from '../sim/commands';
import { clamp, fpFromWorld } from '../sim/fixed';
import type { SimConfig } from '../sim/config';
import type { PlayerId } from '../sim/state';
import type { Renderer } from '../render/renderer';

export class InputHandler {
  private queue: Command[] = [];

  constructor(
    private readonly renderer: Renderer,
    private readonly config: SimConfig,
    private readonly localPlayer: PlayerId,
  ) {}

  attach(canvas: HTMLCanvasElement): void {
    canvas.addEventListener('pointerdown', (e) => {
      const rect = canvas.getBoundingClientRect();
      const world = this.renderer.screenToWorld(e.clientX - rect.left, e.clientY - rect.top);
      const maxX = this.config.match.mapSize.width;
      const maxY = this.config.match.mapSize.height;
      this.queue.push({
        type: 'MoveShip',
        playerId: this.localPlayer,
        x: fpFromWorld(clamp(world.x, 0, maxX)),
        y: fpFromWorld(clamp(world.y, 0, maxY)),
      });
    });
  }

  push(command: Command): void {
    this.queue.push(command);
  }

  /** Töm kön — anropas en gång per sim-tick. */
  drain(): Command[] {
    if (this.queue.length === 0) return [];
    const commands = this.queue;
    this.queue = [];
    return commands;
  }
}
